import userStateApi from '@/api/user-state'
import { PAGE_GROUP } from '@/constants/page'
import { FEATURE } from '@/constants/feature'

function state() {
  return {
    items: []
  }
}

const getters = {
  options: (state, getters, rootState, rootGetters) => (t) => {
    if (rootGetters.selectedBot.page_group === PAGE_GROUP.SRICHAND) {
      return [
        {
          text: t('member'),
          value: 'member'
        },
        {
          text: t('non_member'),
          value: 'not_member'
        }
      ]
    }

    return state.items
      .filter((item) => !!item.user_state)
      .map((item) => ({
        text: item.user_state,
        value: item.user_state
      }))
  }
}

const SET_ITEMS = 'SET_ITEMS'

const mutations = {
  [SET_ITEMS](state, payload) {
    state.items = payload
  }
}

const actions = {
  async fetch({ commit, rootGetters }) {
    if (
      ![PAGE_GROUP.SRICHAND].includes(rootGetters.selectedBot.page_group) &&
      !(rootGetters.selectedBot.features || '').split(',').includes(FEATURE.USER_STATE)
    )
      return

    try {
      const response = await userStateApi.getUserStates({
        page_id: rootGetters.selectedBot.pageid,
        limit: 1000,
        offset: 0
      })
      const { data } = response.data
      commit(SET_ITEMS, data)
    } catch (error) {
      console.error(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user-state.js